import { Button, Tooltip } from "@alpacahq/ui/old";
import { DataGrid } from "@alpacahq/ui/old/datagrid";

import { WhitelistDetailsModal } from "./presentation/WhitelistDetailsModal";
import type { WhitelistTableControllerReturn } from "./WhitelistTable.controller";

export interface WhitelistTablePresentationProps
  extends WhitelistTableControllerReturn {}

export const WhitelistTablePresentation = ({
  whitelist,
  onAddWhitelistAddressClicked,
}: WhitelistTablePresentationProps) => (
  <section className="flex flex-col gap-4">
    <div className="flex items-center justify-between gap-2">
      <h2 className="m-0 p-0 font-semibold text-base text-gray-950">
        <Tooltip content="Withdrawals can only be authorized to addresses in the whitelist. If you do not control the address submitted you may incur in loss of funds.">
          <span className="cursor-help underline decoration-dotted underline-offset-4">
            Whitelist Addresses
          </span>
        </Tooltip>
      </h2>
      <Button
        variant="v2/filled"
        size="v2/base"
        onClick={onAddWhitelistAddressClicked}
      >
        Add New Address
      </Button>
    </div>
    <DataGrid
      variant="modern"
      key="whitelist-address"
      isLoading={whitelist.isLoading || whitelist.tableProps.isLoading}
      rows={whitelist.tableProps.rows}
      columns={whitelist.tableProps.columns}
      emptyMessage="Add an address to enable withdrawals."
    />
    <WhitelistDetailsModal {...whitelist.detailsModal} />
  </section>
);
